import {observer} from "mobx-react";
import styled from "styled-components";
import Input from "@/components/common/Input";
import {HiMagnifyingGlass} from "react-icons/hi2";
import {SIZES} from "@/components/constants";
import React, {useState} from "react";
import {useStore} from "@/store";
import {useRouter} from "next/navigation";
import {useMediaQuery} from "react-responsive";

const FloatSearch = observer(() => {
    const [allSearchWord, setAllSearchWord] = useState("");
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const {floatAreaStore} = useStore();
    const router = useRouter();
    const searchFunc = () => {
        if (!allSearchWord) {
            alert("내용을 입력해 주세요.");
            return;
        }
        router.push(`/homepage/search?searchString=${allSearchWord}`);
        floatAreaStore.setFloatingClear();
        setAllSearchWord("");
    }
    return(
        <FloatSearchWrap>
            <div className={"title"}>
                검색으로 간편하게<br />
                원하는 웅비메디텍의 정보를 찾아보세요.
            </div>
            <div className={"search-form-wrap"}>
                <Input
                    inputType="text"
                    placeholder="검색어를 입력하세요."
                    width={"fill"}
                    height={`${!isTablet ? 70+"px": 48+"px"}`}
                    radius={"99px"}
                    brand={true}
                    value={allSearchWord}
                    onChange={(e) => {
                        setAllSearchWord(e.target.value)
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            searchFunc();
                        }
                    }}
                />
                <div className={"search-tool"}
                    onClick={async () => {
                        searchFunc();
                    }}
                >
                    <HiMagnifyingGlass color={"#4939B1"} size={24}/>
                </div>
            </div>
        </FloatSearchWrap>
    )
});
const FloatSearchWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 0 178px 0 48px;

    .title {
        font-weight: 700;
        font-size: 32px;
        line-height: 140%;
        text-align: center;
        color: #333333;
    }

    .search-form-wrap {
        margin-top: 30px;
        width: 100%;
        position: relative;

        .input-wrapper {
            padding: 0 70px 0 40px;

            input {
                font-weight: 400;
                font-size: 16px;
                color: #4939B1;
            }
        }

        .search-tool {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 40px;
            z-index: 10;
            cursor: pointer;
        }
    }

    .search-list {
        width: 100%;
        padding: 24px 10px 24px 40px;
        max-height: 220px;
        overflow: hidden;
        margin-top: 12px;
        background: #F3F2F9;
        border: 1px solid #E6E6E6;
        border-radius: 30px;

        .search-list-wrap {
            height: 100%;
            padding-right: 30px;
            overflow: auto;

            .search-list-summery {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 15px;
                border-bottom: 1px solid #CCCCCC;
    
                .search-word {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    color: #333333;
    
                    span {
                        font-weight: 600;
                        color: #246FF2;
                    }
                }
    
                .search-length {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 22px;
                    color: #246FF2;
                }
            }
    
            .search-list-inner {
                padding-top: 15px;
                .item-wrap {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    color: #333333;
                    height: 32px;
                    margin-top: 4px;
                    display: flex;
                    align-items: center;
                    padding: 0 12px;
                    cursor: pointer;
                    transition: all .1s ease-in-out;
                    gap: 3px;
                    &:first-child {
                        margin: 0;
                    }
                    &:hover{
                        background-color: #EBE9F4;
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 72px 37px 0;
        justify-content: start;
        .title {
            font-weight: 700;
            font-size: 18px;
            line-height: 140%;
            color: #333333;
        }
        .search-form-wrap{

            .input-wrapper{
                padding: 0 50px 0 24px;
            }
            .search-tool{
                right: 20px;
            }
        }
        .search-list {
            padding: 24px 6px 24px 16px;

            .search-list-wrap {
                padding-right: 10px;
                .search-list-summery {
                    padding-bottom: 8px;

                    .search-word {
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 18px;
                        span {
                            font-weight: 600;
                            color: #246FF2;
                        }
                    }

                    .search-length {
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 18px;
                    }
                }

                .search-list-inner {
                    padding-top: 8px;
                    .item {
                        height: 30px;
                        padding: 0;
                        font-weight: 400;
                        font-size: 14px;
                        &:hover{
                            background-color: #F3F2F9;
                        }
                    }
                }
            }
        }
    }
`
export default FloatSearch;
